module.exports = __webpack_public_path__ + "static/microsoft_365_1-3e2e335e437f3a599f72f876a799de25.png";